// extracted by mini-css-extract-plugin
module.exports = {"container":"error_component_container__dtbcu","errorBody":"error_component_errorBody__E3vFp","actions":"error_component_actions__GRY90"};